export class ZipManagerV1Impl {
    constructor(options) {
        this.listeners = new Set();
        this.zipcookiename = 'user_zip';
        this.locationAuthCookieName = 'allow_browser_location';
        this.setLocationAuth = () => {
            try {
                if (navigator.geolocation) {
                    navigator.geolocation.watchPosition(() => {
                        this.setLocationAuthCookie('allow');
                    }, (error) => {
                        if (error.code === error.PERMISSION_DENIED) {
                            this.setLocationAuthCookie('block');
                        }
                    });
                }
            }
            catch (error) {
                console.log('SET LOCATION COOKIE ERROR:: ', error);
            }
        };
        this.countryCode = options.countryCode;
        this.zip = '';
        this.ipZip = '';
        this.zipModalActive = false;
    }
    getZip() {
        return this.zip;
    }
    setZip(zip) {
        this.zip = zip;
        this.notifyListeners();
    }
    getZipModalActive() {
        return this.zipModalActive;
    }
    setZipModalActive(zipModalActive) {
        this.zipModalActive = zipModalActive;
    }
    getIpZip() {
        return this.ipZip;
    }
    setIpZip(zip) {
        this.ipZip = zip;
    }
    getZipCookie() {
        return this.getCookie(this.zipcookiename);
    }
    getLocationAuthCookie() {
        return this.getCookie(this.locationAuthCookieName);
    }
    setZipCookie(zip) {
        this.deleteZipCookie();
        const endDate = new Date();
        endDate.setMonth(endDate.getMonth() + 1);
        document.cookie = `${this.zipcookiename}=${zip}; expires=${endDate}; path=/`;
        this.setZip(zip);
    }
    setLocationAuthCookie(permission) {
        this.deleteLocationAuthCookie();
        const endDate = new Date();
        endDate.setMonth(endDate.getMonth() + 1);
        document.cookie = `${this.locationAuthCookieName}=${permission}; expires=${endDate}; path=/`;
    }
    deleteZipCookie() {
        document.cookie =
            this.zipcookiename + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    }
    deleteLocationAuthCookie() {
        document.cookie =
            this.locationAuthCookieName +
                '=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    }
    async updateZipInformation(urlZip, ipZip) {
        const result = {
            status: false,
            response: '',
        };
        const getResult = (pZip, pStatus) => {
            this.setZip(pZip);
            this.setIpZip(ipZip);
            result.status = pStatus;
            result.response = this.getZipCookie();
            return result;
        };
        return new Promise((resolve, reject) => {
            if (this.getZipCookie()) {
                resolve(getResult(urlZip ? urlZip : this.getZipCookie(), true));
            }
            else if (!urlZip &&
                (!this.getLocationAuthCookie() ||
                    this.getLocationAuthCookie() === 'allow')) {
                this.detectBrowserLocation(true)
                    .then(() => {
                    resolve(getResult(urlZip ? urlZip : this.getZip(), true));
                })
                    .catch((error) => {
                    console.log('Errors fetching detectBrowserLocation:' + error);
                    reject(getResult(urlZip ? urlZip : ipZip, false));
                })
                    .finally(() => {
                    this.setLocationAuth();
                });
            }
            else {
                resolve(getResult(urlZip ? urlZip : ipZip, true));
            }
        });
    }
    createAuthorizationHeader(username, password) {
        if (!password || !username) {
            return undefined;
        }
        return {
            Authorization: `Basic ${Buffer.from(`${username}:${password}`).toString('base64')}`
        };
    }
    async detectBrowserLocation(storeZip) {
        const result = {
            status: false,
            response: '',
        };
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                const onSuccess = (position) => {
                    const timeout = 5000; // ms to wait for google API to load after getting local geolocation. API could load before lat
                    let timetaken = 0;
                    const waiter = () => {
                        if (window &&
                            window.google &&
                            window.google.maps &&
                            window.google.maps.Geocoder) {
                            try {
                                const geocoder = new google.maps.Geocoder();
                                const latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                                geocoder.geocode({
                                    latLng: latlng,
                                }, (results, status) => {
                                    try {
                                        window.res = results;
                                        // x is a throwaway variable here and each step could evaulate to falsey. That's why I'm assigning in the conditional.
                                        let x = null;
                                        if (status === google.maps.GeocoderStatus.OK &&
                                            Array.isArray(results)) {
                                            x = results.find((el) => JSON.stringify(el).indexOf('postal_code') >= 0);
                                            if (x) {
                                                x = x.address_components.find((el) => el.types[0] === 'postal_code');
                                                if (x && /^(\d{5})$/.test(x.long_name || '')) {
                                                    x = RegExp.$1;
                                                    if (x) {
                                                        if (storeZip) {
                                                            this.setZip(x);
                                                        }
                                                        result.status = true;
                                                        result.response = x;
                                                        this.notifyListeners();
                                                        resolve(result);
                                                    }
                                                    else {
                                                        reject(result);
                                                    }
                                                }
                                                else {
                                                    reject(result);
                                                }
                                            }
                                            else {
                                                reject(result);
                                            }
                                        }
                                        else {
                                            reject(result);
                                        }
                                    }
                                    catch (err) {
                                        reject(result);
                                    }
                                });
                            }
                            catch (err) {
                                reject(result);
                            }
                        }
                        else if (timetaken <= timeout) {
                            console.log('Geolocation ERROR : Waiting...');
                            setTimeout(() => {
                                waiter();
                            }, 200);
                            result.response = 'Geolocation ERROR: time out';
                            timetaken += 200;
                        }
                        else {
                            reject(result);
                        }
                    };
                    waiter();
                };
                const onFailure = (err) => {
                    result.response =
                        'Geolocation ERROR: Geolocation not allowed: ' + err;
                    reject(result);
                };
                try {
                    //hack to force work the timeout
                    navigator.geolocation.getCurrentPosition(function () { }, function () { }, {});
                    navigator.geolocation.getCurrentPosition(onSuccess, onFailure, {
                        timeout: 10000,
                    });
                }
                catch (error) {
                    result.response = 'Geolocation ERROR : Could not fetch the lat long';
                    reject(result);
                }
            }
            else {
                result.response =
                    'Geolocation ERROR: Geolocation not allowed or browser too old';
                reject(result);
            }
        });
    }
    async getZipByIp(countryCode, storeZip, baseUrl, serviceConfigsServiceConfig, mockIds) {
        var _a, _b;
        this.countryCode = countryCode;
        let result = {
            status: false,
            response: '',
        };
        if (this.countryCode === 'US' || this.countryCode === 'DE') {
            // go to /iptozip and get zip
            let url = '/en.service-config.json';
            const params = new URLSearchParams({ countryCode });
            let serviceJson;
            let serviceAuthHeader = undefined;
            if (baseUrl) {
                url = `${baseUrl}/en.service-config.json`;
            }
            if (serviceConfigsServiceConfig) {
                serviceJson = JSON.parse(serviceConfigsServiceConfig);
                params.set('serviceConfigsServiceConfig', serviceConfigsServiceConfig);
                url = `${serviceJson.urlOrigin}${serviceJson.urlPath}`;
                serviceAuthHeader = this.createAuthorizationHeader((_a = serviceJson.credentials) === null || _a === void 0 ? void 0 : _a.username, (_b = serviceJson.credentials) === null || _b === void 0 ? void 0 : _b.password);
            }
            if (mockIds) {
                //params.set('mockIds', mockIds);
                url = `https://latest.mocks.type1-fa.com/?mockRequest=%7B%22originalRequest%22%3A%7B%22href%22%3A%22https%3A%2F%2Flatest.mocks.type1-fa.com%2Fservice-config%22%2C%22headers%22%3A%7B%22Authorization%22%3A%22Basic+b25laHViLXVzZXI6NEtNakFqOUJWajJqYmtU%22%7D%7D%2C%22serviceName%22%3A%22service-config%22%2C%22mockIds%22%3A%5B%22en%22%5D%7D`;
            }
            console.log(`url zipmodule ${url}`);
            try {
                const response = await fetch(url, {
                    method: 'GET',
                    mode: 'cors',
                    headers: Object.assign({}, serviceAuthHeader),
                });
                if (response.ok) {
                    let serviceJson = await response.json();
                    if (!serviceJson.configs.iptozip) {
                        result.status = false;
                        result.response = 'No iptozip service is configured on the cms.';
                        console.log('getZipByIp():' + result.response);
                        return result;
                    }
                    let ipToZipUrl = serviceJson.configs.iptozip.urlOrigin + serviceJson.configs.iptozip.urlPath;
                    const responseIptoZip = await fetch(ipToZipUrl, {
                        method: 'GET',
                        mode: 'cors',
                    });
                    if (responseIptoZip.ok && responseIptoZip.headers.get("x-user-zip")) {
                        this.ipZip = responseIptoZip.headers.get("x-user-zip");
                        if (storeZip) {
                            this.setZip(this.ipZip);
                        }
                        result.status = true;
                        result.response = this.ipZip;
                        this.notifyListeners();
                        console.log('getZipByIp():' + result.response);
                    }
                    else {
                        result.status = false;
                        result.response = "No Zip on the CDN or bad request";
                    }
                    //return result;
                }
                else {
                    result.status = false;
                    result.response = "Bad request to the service config CMS";
                }
                //throw new Error('Something went wrong');
            }
            catch (err) {
                result.status = false;
                console.log("Something went wrong fetching the iptozip service", err);
                result.response = "Something went wrong fetching the iptozip service";
            }
        }
        console.log('getZipByIp():' + result.response);
        return result;
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }
    getCookie(cname) {
        const name = cname + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (const value of ca) {
            let c = value;
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
    notifyListeners() {
        this.listeners.forEach((listener) => listener());
    }
}
